/**
 * 格式化number或string类型的金额等数据保留2位小数
 * value 数据
 * point 保留的小数位数
 * type money（1234 => 1,234.00）/ number（1234 => 1,234）
 * **/
import request from "../../src/util/request";
const reg = /\d{1,3}(?=(\d{3})+$)/g;
const formatMoney = (value, point = 2, type = "money") => {
  let unit = "";
  if (typeof Number(value) === "number" && String(Number(value)) !== "NaN") {
    unit = value / 100000000 > 1 ? "亿" : value / 10000 > 1 ? "万" : "";
    value =
      value / 100000000 > 1
        ? Number(value / 100000000).toFixed(point)
        : value / 10000 > 1
        ? Number(value / 10000).toFixed(point)
        : Number(value).toFixed(type === "money" ? 2 : 0);
  } else {
    value = Number(0).toFixed(point);
    unit = "";
  }

  if (value.includes(".")) {
    value = value.split(".");
    value[0] = value[0].replace(reg, "$&,");
    value = value.join(".");
  } else {
    value = value.replace(reg, "$&,");
  }
  return { value, unit };
};

//获取推荐位信息
/**
 * type:推荐位类型1:广告推荐位  2：商品推荐位
 *
 * recommondKey：推荐位的key
 * dom:不传默认跟对应环境走
 */
export const getRecommondInfo = (type, jsonp, recommondKey, dom) => {
  let url = "";
  if (type == 1) {
    url = `https://ustatic.${domainEnv()}ulecdn.com/mobilead/itemRecommend/sectionList/${jsonp}/${recommondKey}/0`;
    if (dom == "prd") {
      url = `https://ustatic.ulecdn.com/mobilead/itemRecommend/sectionList/${jsonp}/${recommondKey}/0`;
    }
  } else if (type == 2) {
    url = `https://ustatic.${domainEnv()}ulecdn.com/mobilead/itemRecommend/moduleList/${jsonp}/0/${recommondKey}/0`;
    if (dom == "prd") {
      url = `https://ustatic.ulecdn.com/mobilead/itemRecommend/moduleList/${jsonp}/0/${recommondKey}/0`;
    }
  }
  return request.jsonp(url, {}, "", jsonp);
};
export const getRecommondData = (jsonp, recommondKey) => {
  let url = `https://ustatic.ulecdn.com/mobilead/ylwIndex/getIndexDataByCatId/${jsonp}/310000/310100/310115/310115005/${recommondKey}.html?jsonpcallback=${jsonp}`;
  return request.jsonp(url, {}, "", jsonp);
};

const formatThousandth = value => {
  if (typeof Number(value) === "number" && String(Number(value)) !== "NaN") {
    value = String(value);
  } else {
    value = "0";
  }
  if (value.includes(".")) {
    value = value.split(".");
    value[0] = value[0].replace(reg, "$&,");
    value = value.join(".");
  } else {
    value = value.replace(reg, "$&,");
  }
  return value;
};

const formatProvName = (value, showUnit) => {
  let province = value.replace(
    /省|市|自治区|特别行政区|片区局|区局|片区|区|县|维吾尔|回族|壮族|邮电局|邮政局|邮政公司|邮政所|邮政支局|分公司|营业局|邮政|（|）/gi,
    ""
  );
  let provAlias = {
    北京: "市",
    天津: "市",
    上海: "市",
    重庆: "市",
    内蒙古: "自治区",
    广西: "壮族自治区",
    西藏: "自治区",
    宁夏: "回族自治区",
    新疆: "维吾尔自治区",
    香港: "特别行政区",
    澳门: "特别行政区"
  };
  if (showUnit) {
    province += provAlias[province] || "省";
  }
  return province;
};

const formatProvRank = (fmt, list) => {
  const rankList = list.reduce((list, item) => {
    list.push({
      ...item,
      name: formatProvName(item[fmt.nameKey]),
      value: item[fmt.valueKey]
    });
    return list;
  }, []);
  rankList.sort((item1, item2) => item2.value - item1.value);
  return rankList;
};

// 格式化时间
const formatTime = (date, fmt = "yyyy-MM-dd hh:mm:ss") => {
  const o = {
    "y{4}": date.getFullYear(),
    "M{2}": date.getMonth() + 1,
    "d{2}": date.getDate(),
    "h{2}": date.getHours(),
    "m{2}": date.getMinutes(),
    "s{2}": date.getSeconds()
  };
  for (const key in o) {
    if (new RegExp(`(${key})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        o[key].toString().length === 1 ? `0${o[key]}` : o[key]
      );
    }
  }
  return fmt;
};

const formatWidgetsData = data => {
  let dataset = {};
  data.widgets.map(widget => {
    dataset[widget.widget_name] = {};
    widget.metrics.map(metric => {
      dataset[widget.widget_name][metric.metric_name] = metric.metric_value;
    });
  });
  return dataset;
};

// 数据维度转换
const formatMetricsData = (dataset, widget, metrics) => {
  let data = {};
  if (dataset[widget]) {
    for (let item in metrics) {
      if (metrics[item] && typeof metrics[item] == "string") {
        data[item] = dataset[widget][metrics[item]] || "";
      } else {
        data[item] = metrics[item];
      }
    }
  }
  return data;
};

// 将Object数据格式化为数组
const formatObjectItemArray = (data, options) => {
  let total = 0,
    items = [];
  options = options || {};
  if (typeof data == "object") {
    for (let item in data) {
      items.push({
        name: options.provAlias ? formatProvName(item, true) : item,
        value: data[item]
      });
      total += data[item] * 1;
    }
    if (options.calcRatio) {
      items.map(item => {
        item.ratio =
          ((item.value * 100) / total).toFixed(options.ratioDecimal || 0) * 1;
      });
    }
  }
  return items;
};

// 处理mapdata
const formatMapProvinceData = (provinces, dataset, params) => {
  for (let item in params) {
    if (params[item]) {
      let data = dataset[params[item]];
      if (data) {
        for (let prov in data) {
          let province = formatProvName(prov, true);
          if (!provinces[province]) {
            provinces[province] = {};
          }
          provinces[province][item] = data[prov];
        }
      }
    }
  }
};
const formatMapProvinceItems = (provinces, dataset, params) => {
  for (let item in params) {
    if (params[item]) {
      let data = dataset[params[item]];
      if (data) {
        for (let prov in data) {
          let province = formatProvName(prov, true);
          let items = [];
          if (!provinces[province]) {
            provinces[province] = {};
          }
          for (let chn in data[prov]) {
            let chndata = data[prov][chn];
            items.push({
              title: chn,
              gmv: chndata["销售额"],
              buyer: chndata["买家数"],
              order: chndata["订单数"]
            });
          }
          provinces[province][item] = items;
        }
      }
    }
  }
};

const mapCoord = {
  北京市: [116.41989, 40.189913],
  天津市: [117.351154, 39.28914],
  河北省: [115.202461, 39.345474],
  山西省: [112.305144, 37.619053],
  内蒙古自治区: [113.059024, 43.815561],
  辽宁省: [123.106135, 41.300702],
  吉林省: [126.171246, 43.703944],
  黑龙江省: [127.693002, 48.040469],
  上海市: [121.438732, 31.072508],
  江苏省: [119.98196, 32.985864],
  浙江省: [120.109522, 29.181876],
  安徽省: [117.226894, 31.849585],
  福建省: [118.005928, 26.070282],
  江西省: [115.732937, 27.636129],
  山东省: [118.186283, 36.374485],
  河南省: [113.619918, 33.902738],
  湖北省: [112.271042, 30.98802],
  湖南省: [111.754313, 27.655081],
  广东省: [113.429877, 23.334664],
  广西壮族自治区: [108.794237, 23.833575],
  海南省: [109.754777, 19.189617],
  重庆市: [107.88398, 30.067321],
  四川省: [102.693438, 30.674548],
  贵州省: [106.88108, 26.826362],
  云南省: [101.485108, 25.008649],
  西藏自治区: [88.388277, 31.56375],
  陕西省: [108.887567, 35.263665],
  甘肃省: [102.523557, 38.358039],
  青海省: [96.043531, 35.726402],
  宁夏回族自治区: [106.169867, 37.291331],
  新疆维吾尔自治区: [85.294712, 41.371801],
  台湾省: [120.971486, 23.749452],
  香港特别行政区: [114.134394, 22.377371],
  澳门特别行政区: [113.56642, 22.159262]
};

// 地图显示名称偏移
export const mapName = {
  北京市: [0, -15],
  天津市: [0, 20],
  河北省: [-20, 20],
  山西省: [-2, 20],
  内蒙古自治区: [-10, 20],
  辽宁省: [10, 20],
  吉林省: [0, 15],
  黑龙江省: [0, 15],
  上海市: [23, 5],
  江苏省: [10, 20],
  浙江省: [-3, 20],
  安徽省: [0, 20],
  福建省: [0, 20],
  江西省: [-5, 15],
  山东省: [0, 20],
  河南省: [0, 20],
  湖北省: [0, 20],
  湖南省: [0, 15],
  广东省: [0, 10],
  广西壮族自治区: [5, 20],
  海南省: [0, 15],
  重庆市: [0, 20],
  四川省: [0, 20],
  贵州省: [3, 20],
  云南省: [0, 15],
  西藏自治区: [-3, 15],
  陕西省: [0, 15],
  甘肃省: [28, 10],
  青海省: [-4, 15],
  宁夏回族自治区: [0, 15],
  新疆维吾尔自治区: [0, 13],
  台湾省: [0, 0],
  香港特别行政区: [0, 0],
  澳门特别行政区: [0, 0]
};

export const domainEnv = () => {
  let env = process.env.NODE_ENV;
  env = "production"; //测试用生产数据
  if (env == "development") {
    return "beta.";
  } else if (env == "testing") {
    return "testing.";
  } else if (env == "production") {
    return "";
  }
};

export const getDomain = () => {
  return /localhost|.beta.ule|127.0.0.1|192.168/.test(location.hostname)
    ? "beta."
    : /.testing.ule/.test(location.hostname)
    ? "testing."
    : "";
};

export const throttle = (method, mustRunDelay) => {
  let timer,
    args = arguments,
    start;
  return function loop() {
    let self = this;
    let now = Date.now();
    if (!start) {
      start = now;
    }
    if (timer) {
      clearTimeout(timer);
    }
    if (now - start >= mustRunDelay) {
      method.apply(self, args);
      start = now;
    } else {
      timer = setTimeout(function() {
        loop.apply(self, args);
      }, 50);
    }
  };
};

export const isChinese = s => {
  let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
  if (reg.test(s)) {
    return true;
  } else {
    return false;
  }
};

export default {
  formatMoney,
  formatThousandth,
  formatProvName,
  formatProvRank,
  formatTime,
  formatWidgetsData,
  formatMetricsData,
  formatObjectItemArray,
  formatMapProvinceData,
  formatMapProvinceItems,
  mapCoord,
  mapName,
  domainEnv,
  getRecommondInfo,
  getDomain
};



// WEBPACK FOOTER //
// ./src/util/common.js